module.exports = __webpack_public_path__ + "img/49800.af744c97.jpg";